import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FormComponent } from '@classes/form';
import { AlertType } from '@components/alert/alert.component';

@Component({
  selector: 'app-footer',
  imports: [FormsModule, RouterLink],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.scss',
})
export class Footer extends FormComponent {
  protected email = '';

  protected readonly socialLinks = [
    {
      icon: 'fab fa-youtube',
      url: 'https://www.youtube.com/channel/UCsD71qFZPW42WbdW-aVg8vA',
      label: 'YouTube',
    },
    {
      icon: 'fab fa-tiktok',
      url: 'https://www.tiktok.com/@arteyculturags',
      label: 'TikTok',
    },
    {
      icon: 'fab fa-x-twitter',
      url: 'https://twitter.com/arteyculturags',
      label: 'Twitter',
    },
    {
      icon: 'fab fa-instagram',
      url: 'https://www.instagram.com/arteyculturags/',
      label: 'Instagram',
    },
    {
      icon: 'fab fa-facebook',
      url: 'https://www.facebook.com/arteyculturags',
      label: 'Facebook',
    },
  ];

  ngOnInit(): void {
    this.endpoint = 'api/newsletter';
    this.method = 'post';
  }

  override getParams() {
    return {
      email: this.email,
      section: 'footer',
    };
  }

  override success(response: any): void {
    this.email = '';
    alert('Gracias por suscribirse');
    super.success(response);
  }

  override handleAlert(message: string, type?: AlertType): void {
    alert(message);
  }
}
